






















































import { Component, Vue, Prop } from 'vue-property-decorator'
import * as qs from 'qs'
import { requireGet, requirePost } from '../require'
import { env } from '@ivy/fts/envInfo/envInfo'
@Component({
  filters: {
    addressConverter: receiver => {
      return (
        receiver.province_name +
        receiver.city_name +
        receiver.district_name +
        receiver.address
      )
    },
  },
})
export default class AddressList extends Vue {
  userReceivers: any = []
  receiverIdChecked: any
  redirect: any = ''
  receiver: any
  channelId: any
  order: any
  result: any
  show: boolean = false
  mode: string = 'list' // list(地址管理)) or select（地址选择）

  async mounted() {
    const { channel_id, result, total_fee, ...order } = qs.parse(
      this.$route.query
    )
    this.result = result
    // 上报转化, 非0元商品付款成功
    if (total_fee > 0 && !result.includes('chooseWXPay:ok')) {
      this.$router.go(-1)
    }

    this.order = order.order
    this.channelId = channel_id

    await env.init()
    if (env.type === 'web') return this.$Toast('请在微信中打开')
    if (!(await env.getIsLogin())) {
      return await env.login()
    }

    const loginInfo = await env.getInfo()
    const token =
      env.type === 'wx' ? loginInfo.logined.token : loginInfo.publicParams.token

    this.mode = 'select'
    this.redirect = this.$route.query.redirect
    token && (await this.getAllUserReceiver())
    this.show = true
  }
  async getAllUserReceiver() {
    let { data } = await this.$axios.post(
      `/api/mobile/course/yaya/getUserReceiver`
    )
    this.userReceivers = data

    // 初始化选择默认地址
    if (
      this.mode === 'select' &&
      this.userReceivers &&
      this.userReceivers.length
    ) {
      if (this.$route.query.receiverId) {
        this.receiverIdChecked = this.$route.query.receiverId
        return
      }
      let defaultReceiver = this.userReceivers.find(receiver => {
        return receiver.is_default
      })
      defaultReceiver && (this.receiverIdChecked = defaultReceiver.id)
    }
  }
  async onShowModifyAddress() {
    this.$router.push({
      path: '/invitationMarket/modifyAddress',
      query: { mode: 'create' },
    })
  }
  async onConfirmAddress(receiver) {
    this.receiver = receiver
    await requirePost('/api/activity/crm/put/compeleteOrderInfo', {
      provinceName: receiver.province_name,
      cityName: receiver.city_name,
      countyName: receiver.district_name,
      detailInfo: receiver.address,
      userName: receiver.name,
      telNumber: receiver.phone,
      receiverId: receiver.id,
      tid: this.order.tid,
    })

    let redirect = decodeURIComponent(this.redirect)
    return window.location.replace(
      redirect + `&receiver_id=${receiver.id}&result=${this.result}`
    )
  }
  onEditReceiver(receiver) {
    this.$router.push({
      path: '/invitationMarket/modifyAddress',
      query: { mode: 'modify', id: receiver.id },
    })
  }
}
